import url from '../../constants/urlList';

// Settings → Delete account (iOS ruling B1). The fetch interceptor supplies the bearer token.
// Errors carry a stable code only; server text is never shown verbatim.
const DELETION_PATH = '/qlearn/user/me/deletion';

// A 503 the service sends itself (it carries the service's JSON body) means Stripe failed and
// nothing was deleted. Any other 5xx, a gateway's 503, or a 2xx without a readable body may have
// come after the deletion started, so the outcome is unconfirmed.
const codeFor = (status, data) => {
  if (status === 401) return 'SIGNED_OUT';
  if (status === 409) return 'TRY_LATER';
  if (status === 503 && data) return 'NOTHING_DELETED';
  if (status >= 500 || (status >= 200 && status < 300)) return 'UNCONFIRMED';
  return 'REQUEST_FAILED';
};

const request = async (body) => {
  try {
    const response = await fetch(`${url.domain}${DELETION_PATH}`, {
      method: body === undefined ? 'GET' : 'POST',
      headers: { 'Content-Type': 'application/json' },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
    // The fetch interceptor answers nothing when this tab has no usable session to send.
    if (!response) return { ok: false, code: 'NO_SESSION' };
    const data = await response.json().catch(() => null);
    if (response.status >= 200 && response.status < 300 && data) return { ok: true, data };
    return { ok: false, code: codeFor(response.status, data) };
  } catch (_) {
    // The request may or may not have reached the server. If it did, the account is gone and
    // its session with it, so a retry gets a 401; the screen treats that as deleted.
    return { ok: false, code: 'NETWORK_ERROR' };
  }
};

export const getDeletionPreview = () => request(undefined);

// The only caller is the destructive button; the server refuses anything but 'DELETE'.
export const confirmDeletion = () => request({ confirm: 'DELETE' });
